import { render, staticRenderFns } from "./NIFPS.vue?vue&type=template&id=a961e2ac&scoped=true"
import script from "./NIFPS.vue?vue&type=script&lang=js"
export * from "./NIFPS.vue?vue&type=script&lang=js"
import style0 from "./NIFPS.vue?vue&type=style&index=0&id=a961e2ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a961e2ac",
  null
  
)

export default component.exports